<template>
  <div class="reg-icon">
    <img :src="svg" >
  </div>
</template>
<script>
import reg0 from './reg0.svg'
import reg1 from './reg1.svg'
import reg2 from './reg2.svg'
import reg3 from './reg3.svg'

const pics = [reg0, reg1, reg2, reg3]

export default {
  name: 'RegistrationIcon',
  props: {
    value: Number
  },
  computed: {
    svg() {
      return pics[this.value]
    }
  }
}
</script>
<style scoped>
.reg-icon {
  display: inline-block;
}
</style>
